import { render, staticRenderFns } from "./NavigationItemListScreen.vue?vue&type=template&id=f8549a52&"
import script from "./NavigationItemListScreen.vue?vue&type=script&lang=ts&"
export * from "./NavigationItemListScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports